export default "__VITE_ASSET__c3f58b72__"